<template>
  <section id="info" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">招租公告其他事项</div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="fixed-13-desc">
      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">招租公告起始日期</span>
        </template>
        {{ projectStartTimeText }}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">招租公告截止日期</span>
        </template>
        {{ projectEndTimeText }}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">公告发布期（工作日）</span>
        </template>
        {{ bidBaseInfo.disclosurePeriod }}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text"> 招租公告发布期满未征集到意向方 </span>
        </template>
        {{
          bidBaseInfo.disclosurePeriodExtend == 12
            ? `延长发布，不变更招租公告条件，按照 ${
                bidBaseInfo.extendWorkingDays || "--"
              } 工作日为一个延长周期，延长 ${
                bidBaseInfo.extendedCyclesNumber || "--"
              } 周期`
            : bidBaseInfo.disclosurePeriodExtend == 14
            ? "变更招租公告内容，重新申请发布招租"
            : bidBaseInfo.disclosurePeriodExtend == 11
            ? "招租公告发布终结"
            : "--"
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">招租方式</span>
        </template>
        {{
          bidBaseInfo.transactionMode == 1
            ? "网络竞价"
            : bidBaseInfo.transactionMode == 2
            ? "权重报价"
            : bidBaseInfo.transactionMode == 4
            ? "其他竞价"
            : bidBaseInfo.transactionMode == 5
            ? "开放报价"
            : bidBaseInfo.transactionMode == 7
            ? "竞争性谈判"
            : "--"
        }}
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    bidBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    projectStartTimeText() {
      return this.formatEmpty(this.bidBaseInfo.projectStartTime);
    },

    projectEndTimeText() {
      return this.formatEmpty(this.bidBaseInfo.projectEndTime);
    },
  },
  methods: {
    hasValue(value) {
      return value !== undefined && value !== null && value !== "";
    },

    formatEmpty(value) {
      return this.hasValue(value) ? value : "--";
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>